import React from 'react'
import { connect } from 'react-redux'
import { withRouteData } from 'react-static'
import ReCAPTCHA from "react-google-recaptcha";

import {
    getDefaultText,
    getDefaultFrom,
    getDefaultTo,
    getDefaultLang,
    getDefaultLanguage,
    getDefaultFromscript,
    getDefaultToscript,
    getFilteredByCapabilities,
    getMarkedCookieValue,
    getResultId,
    getIntentLanguages
} from 'utils'
import {
    postRequestAPIAction,
    getIntentLanguagesAction,
    resetDemoParamsOnInputChange,
} from 'connectors/redux/actions'

import SelectPicker from '../SelectPicker'
import ProviderAsButton from '../ProviderAsButton'
import TryWarning from '../TryWarning'

import DataInputField from './DataInputField'
import Results from './Results'

function getResultsPlaceholder({ intent, capabilities }) {
    const { from, lang } = capabilities
    if (intent.hasTextInput) {
        return from && from.value
            ? ''
            : 'Select source language to see more models'
    }
    if (intent.hasLanguages) {
        return lang && lang.value ? '' : 'Select language to see more models'
    }

    return ''
}

const recaptchaRef = React.createRef();

class TryAnyIntent extends React.Component {
    constructor(props) {
        super(props)
        const { defaultImage: image, slug, intent } = props
        const capabilities = {
            from: getDefaultFrom(slug),
            to: getDefaultTo(slug),
            lang: getDefaultLang(slug),
            language: getDefaultLanguage(slug),
            fromscript: getDefaultFromscript(slug),
            toscript: getDefaultToscript(slug),
        }
        this.state = {
            ...capabilities,
            languages: [],
            image,
            text: getDefaultText(slug),
            production: getMarkedCookieValue('IPK'),
            token: getMarkedCookieValue('UAT'),
            activeProvider: '',
            pair: getResultId({ slug, intent, capabilities }),
        }
    }

    componentDidMount() {
        this.getLanguages()
    }

    async getLanguages() {
        const { slug } = this.props
        const languages = await getIntentLanguages(slug)
        this.setState({ languages })
    }
    render() {
        const {
            slug,
            intent,
            intentProviders,
            intentLanguages,
            postRequestAPI,
        } = this.props
        const { results = {}, errors = {}, pending } =
            postRequestAPI[slug] || {}
        const {
            text,
            image,
            from,
            to,
            language,
            fromscript,
            toscript,
            activeProvider = '',
            pair = '',
        } = this.state

        let { lang } = this.state
        const capabilities = {
            results,
            errors,
            from,
            to,
            lang,
            language,
            fromscript,
            toscript,
            text,
        }

        let providers = []
        let loading = false
        if (intentProviders[slug]) {
            loading = intentProviders[slug].pending
            if (!loading) {
                providers = intentProviders[slug].response || []
            }
        }

        if (lang === null || lang === undefined) {
            lang = {}
        }

        let demoTitle = 'Put your text and choose a service provider'
        if (intent.hasImageInput) {
            demoTitle = 'Put your image and choose a service provider'
        } else if (intent.hasMediaInput) {
            demoTitle = 'Put your media file and choose a service provider'
        }

        const [currentProvider] = providers.filter(p => p.id === activeProvider)

        const error = (errors[pair] || {})[activeProvider]

        let processedResult =
            (results[pair] || {})[activeProvider] ||
            getResultsPlaceholder({ intent, capabilities })
        try {
            processedResult = JSON.parse(processedResult)
        } catch(e) {
            // ignore error on parse
        }

        if (Array.isArray(processedResult)) {
            [processedResult] = processedResult
        }

        if (typeof processedResult === 'object') {
            processedResult = JSON.stringify(processedResult, null ,'\n')
        }

        const languages = (intentLanguages[slug] || {}).response
        return (
            <section id="mt-demo" className="section try-section">
                <div className="section__container container u-padding-bottom-0">
                    <header className="section__header">
                        <h2 className="section__title">{demoTitle}</h2>
                    </header>
                    <div className="section__content">
                        {this.renderLanguages()}
                        <div className="try-intento">
                            <div className="try-intento__col try-intento__col--left">
                                <div className="try-intento__row try-intento__row--main">
                                    <DataInputField
                                        onChange={this.handleTextChange}
                                        {...{ text, image, intent }}
                                    />
                                </div>
                            </div>
                            <div className="try-intento__col try-intento__col--right">
                                <div className="try-intento__row try-intento__row--main">
                                    <div className="try-intento__input-group">
                                        {this.renderModels()}
                                        <div className="try-intento__input try-intento__input-border">
                                            {pending ? (
                                                <div className="loader">
                                                    <div className="spinner" />
                                                </div>
                                            ) : (
                                                <Results
                                                    slug={slug}
                                                    languages={languages}
                                                    error={error}
                                                    output={processedResult}
                                                    provider={currentProvider}
                                                    capabilities={capabilities}
                                                />
                                            )}
                                            {processedResult && (
                                                <TryWarning
                                                    capabilities={capabilities}
                                                    provider={currentProvider}
                                                    slug={slug}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    // public captcha key
                    sitekey="6LcPtAccAAAAAL88BAUbHxehASDLUucUy9zU3DJs"
                    badge="bottomleft"
                />
            </section>
        )
    }

    renderModels = () => {
        const { intentProviders, slug, postRequestAPI } = this.props
        const {
            pendingProviders = [],
            readyProviders = {},
            failedProviders = {},
        } = postRequestAPI[slug] || {}
        const { activeProvider = '', lang, to, from, pair } = this.state
        const capabilities = { to, from, lang }
        let providers = []
        let loading = false
        if (intentProviders[slug]) {
            loading = intentProviders[slug].pending
            if (!loading) {
                providers = intentProviders[slug].response || []
            }
        }

        const filteredProviders = getFilteredByCapabilities(
            slug,
            providers,
            capabilities
        )

        return (
            <div className="try-intento__choice try-intento__choice--shadowed">
                <h5 className="try-intento__choice-title">
                    Select model ({(readyProviders[pair] || []).length}/
                    {filteredProviders.length}):
                </h5>
                {loading && (
                    <div className="loader">
                        <div className="spinner" />
                    </div>
                )}
                <ul className="try-intento__choice-list">
                    {filteredProviders.map(provider => (
                        <ProviderAsButton
                            key={provider.id}
                            onClick={this.handleSubmit(provider)}
                            active={activeProvider === provider.id}
                            deletable={
                                (failedProviders[pair] || []).indexOf(
                                    provider.id
                                ) !== -1
                            }
                            ready={
                                (readyProviders[pair] || []).indexOf(
                                    provider.id
                                ) !== -1
                            }
                            pending={
                                pendingProviders.indexOf(provider.id) !== -1
                            }
                            {...provider}
                        />
                    ))}
                </ul>
            </div>
        )
    }

    renderLanguages = () => {
        const { slug, intent } = this.props
        const { languages } = this.state
        if (!intent.hasLanguages || !languages || languages.length < 1) {
            return null
        }

        if (slug === 'ai/text/transliterate') {
            const { fromscript, toscript } = this.props
            return (
                <div className="try-intento">
                    <div className="try-intento__col try-intento__col--right">
                        {this.renderFirstLanguage(languages)}
                    </div>
                    <div
                        className="try-intento__col try-intento__col--right"
                        style={{ marginLeft: 10 }}
                    >
                        {this.renderSecondLanguage(
                            fromscript.map(s => ({ value: s, label: s }))
                        )}
                    </div>
                    <div
                        className="try-intento__col try-intento__col--right"
                        style={{ marginLeft: 10 }}
                    >
                        {this.renderThirdLanguage(
                            toscript.map(s => ({ value: s, label: s }))
                        )}
                    </div>
                </div>
            )
        }

        return (
            <div className="try-intento">
                <div className="try-intento__col try-intento__col--left">
                    {this.renderFirstLanguage(languages)}
                </div>
                <div className="try-intento__col try-intento__col--right">
                    {this.renderSecondLanguage(languages)}
                </div>
            </div>
        )
    }

    renderFirstLanguage = languages => {
        const { slug } = this.props
        let label = 'Language'
        let valueGetter = 'lang'

        if (slug === 'ai/text/translate' || slug === 'ai/text/dictionary') {
            label = 'From'
            valueGetter = 'from'
        } else if (slug === 'ai/text/transliterate') {
            valueGetter = 'language'
        }
        return (
            <div className="try-intento__row">
                <div className="try-intento__label">{label}:</div>
                <div className="select">
                    <SelectPicker
                        name={valueGetter}
                        isSearchable
                        placeholder="Select source language"
                        options={languages}
                        value={this.state[valueGetter]}
                        onChange={this.handleSelectChange(valueGetter)}
                    />
                </div>
            </div>
        )
    }

    renderSecondLanguage = languages => {
        const { slug } = this.props
        const withSecondLang = [
            'ai/text/translate',
            'ai/text/dictionary',
            'ai/text/transliterate',
        ]
        if (withSecondLang.indexOf(slug) === -1) {
            return (
                <div className="try-intento__row">
                    <div className="try-intento__label">&nbsp;</div>
                    <div className="select" />
                </div>
            )
        }

        let label = 'To'
        let valueGetter = 'to'
        if (slug === 'ai/text/transliterate') {
            label = 'From script'
            valueGetter = 'fromscript'
        }
        return (
            <div className="try-intento__row">
                <div className="try-intento__label">{label}:</div>
                <div className="select">
                    <SelectPicker
                        name={valueGetter}
                        isSearchable
                        placeholder="Select source language"
                        options={languages}
                        value={this.state[valueGetter]}
                        onChange={this.handleSelectChange(valueGetter)}
                    />
                </div>
            </div>
        )
    }

    renderThirdLanguage = languages => {
        const { slug } = this.props

        if (slug !== 'ai/text/transliterate') {
            return null
        }

        const label = 'To script'
        const valueGetter = 'toscript'

        return (
            <div className="try-intento__row">
                <div className="try-intento__label">{label}:</div>
                <div className="select">
                    <SelectPicker
                        name={valueGetter}
                        isSearchable
                        placeholder="Select source language"
                        options={languages}
                        value={this.state[valueGetter]}
                        onChange={this.handleSelectChange(valueGetter)}
                    />
                </div>
            </div>
        )
    }

    handleTextChange = event => {
        // TODO check if intent is production-ready (translation / sentiment/ dictionary)
        const { slug, dispatch } = this.props
        let { value, name } = event.target
        if (this.state.token && !this.state.production) {
            if (name === 'text') {
                // max allowed text length in the web demo in the sandbox mode is 500 characters.
                if (value.length > 497) {
                    value = `${value.slice(0, 496)}...`
                }
            }
        } 
        this.setState({
            [name]: value,
            activeProvider: '',                
        },
        () => {
            dispatch(resetDemoParamsOnInputChange({ slug }))
        })
    }

    handleSelectChange = name => newValue => {
        const { slug, intent } = this.props
        const { from, to, language, fromscript, toscript } = this.state
        this.setState({
            [name]: newValue,
            activeProvider: '',
            pair: getResultId({
                slug,
                intent,
                capabilities: {
                    from,
                    to,
                    language,
                    fromscript,
                    toscript,
                    [name]: newValue, // rewrite prev lang value with next lang value
                },
            }),
        })
    }

    getContext = () => {
        const { slug } = this.props
        const { languages } = this.state

        if (slug === 'ai/text/translate' || slug === 'ai/text/dictionary') {
            const { text } = this.state
            let { to, from } = this.state
            if (from === null || from === undefined) {
                from = {}
            }
            if (to === null || to === undefined) {
                to = {}
            }
            return { from: from.value, to: to.value, text }
        }

        if (slug === 'ai/text/transliterate') {
            const { text } = this.state
            let { language, fromscript, toscript } = this.state
            if (language === null || language === undefined) {
                language = {}
            }
            if (fromscript === null || fromscript === undefined) {
                fromscript = {}
            }
            if (toscript === null || toscript === undefined) {
                toscript = {}
            }
            return {
                language: language.value,
                fromscript: fromscript.value,
                toscript: toscript.value,
                text,
            }
        }

        if (languages && languages.length > 0) {
            const { text } = this.state
            let { lang } = this.state
            if (lang === null || lang === undefined) {
                lang = {}
            }
            return { lang: lang.value, text }
        }

        if (slug.indexOf('/image/') !== -1) {
            const { image } = this.state
            const params = { image, language: 'english' }
            // allow different image types: `data:image/png;base64,`, `data:image/jpeg;base64,`,
            // `data:image/tiff;base64,`, `data:application/pdf;base64,`,...
            const test = 'base64,'
            if (image.indexOf(test) !== -1) {
                // eslint-disable-next-line no-extra-semi
                ;[, params.image] = image.split('base64,')
            }
            return params
        }

        const { text } = this.state
        return { text }
    }

    handleSubmit = provider => () => {
        const { slug, intent, intentLanguages, postRequestAPI } = this.props
        const { results = {} } = postRequestAPI[slug] || {}
        const { production, pair } = this.state

        this.setState({ activeProvider: provider.id })

        if (!this.state.text && !this.state.image) {
            // nothing to process
            return
        }

        if ((results[pair] || {})[provider.id]) {
            // already processed
            return
        }

        this.setState({}, async () => {
            let token = ''
            if (intent.requireLanguages && !intentLanguages[slug]) {
                const getter = await getIntentLanguagesAction(intent.url)
                // register newly retrieved data in the redux state
                await getter(this.props.dispatch)
            }

            if (!production) {
                token = await recaptchaRef.current.executeAsync();
            }


            // get translation/tagging (the job) results
            const pro = await postRequestAPIAction({
                slug,
                provider,
                keychain: { production },
                data: {
                    context: this.getContext(),
                    service: {
                        provider: provider.id,
                    },
                    token
                },
                pair,
            })
            // register newly retrieved data in the redux state
            await pro(this.props.dispatch)
            recaptchaRef.current && recaptchaRef.current.reset()
        })
    }
}

function mapStateToProps(state) {
    return {
        intentProviders: state.intentProviders || {},
        intentLanguages: state.intentLanguages || {},
        postRequestAPI: state.postRequestAPI || {},
    }
}

export default connect(mapStateToProps)(withRouteData(TryAnyIntent))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/TryAnyIntent/index.jsx